import { createFileRoute } from "@tanstack/react-router";
import { SearchTab } from "./settings.catalog";

export const Route = createFileRoute("/settings/catalog/search")({
	component: SearchTab,
});
